import { render, staticRenderFns } from "./V2ScheduleCollectionModal.vue?vue&type=template&id=39327a1a&scoped=true&"
import script from "./V2ScheduleCollectionModal.vue?vue&type=script&lang=js&"
export * from "./V2ScheduleCollectionModal.vue?vue&type=script&lang=js&"
import style0 from "./V2ScheduleCollectionModal.vue?vue&type=style&index=0&id=39327a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39327a1a",
  null
  
)

export default component.exports